import { render, staticRenderFns } from "./Codes.vue?vue&type=template&id=70f45c4c&scoped=true&"
import script from "./Codes.vue?vue&type=script&lang=js&"
export * from "./Codes.vue?vue&type=script&lang=js&"
import style0 from "./Codes.vue?vue&type=style&index=0&id=70f45c4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70f45c4c",
  null
  
)

export default component.exports